<template>
  <DialogTemplateToolkit
    :dialog="dialog"
    :disabled="!files || !files.length"
    :first_btn="first_btn_text || 'Common.Add'"
    :loading="loading"
    :title="title || $t('Tenders.ImportXLSTitle')"
    @apply="applyFunnc"
    @close="close">
    <template #activator-btn>
      <slot
        name="activator"
        :open="open"/>
    </template>
    <template #card-text>
      <div class="import-dialog">
        <div class="px-0 pt-3 h6-text col-10">
          {{ subtitle || $t('Tenders.ImportXLSText') }}
        </div>
        <ImportBlock
          :all-file-types="allFileTypes"
          :create-file-handler="createFileHandler"
          :disabled="disabled || (only_one && !!files.length) || loading"
          :disabled_list="disabled || loading"
          :external-delete="externalDelete"
          :file_size="file_size"
          :files.sync="files_sync"
          :files-types="filesTypes"
          :multiple="!only_one"
          :new-endpoints="newEndpoints"
          :preview="preview"
          @deleteFile="deleteFile"
          @restoreFile="restoreFile"/>
        <div class="px-0 pt-5">
          <slot name="actions"/>
        </div>
      </div>
    </template>
  </DialogTemplateToolkit>
</template>
<script>
import ImportBlock from 'components/common/blocks/ImportBlock.vue'
import DialogTemplateToolkit from 'components/common/dialogs/DialogTemplateToolkit.vue'

export default {
  name: 'importDialog',
  data() {
    return {
      dialog: false
    }
  },
  props: {
    apply: Function,
    title: String,
    subtitle: String,
    only_one: Boolean,
    disabled: Boolean,
    files: Array,
    first_btn_text: String,
    createFileHandler: { type: Function, required: true },
    filesTypes: { type: [Array, Boolean] },
    allFileTypes: Object,
    newEndpoints: Boolean,
    externalDelete: Boolean,
    preview: Boolean,
    file_size: [Number, String],
  },
  computed: {
    loading() {
      return this.files?.some((e) => e.loading)
    },
    files_sync: {
      get() {
        return this.files
      },
      set(value) {
        this.$emit('update:files', value)
      }
    },
  },
  methods: {
    restoreFile(props) {
      const result = this.$_.cloneDeep(this.files_sync)
      result[props.n].deleted = false
      result[props.n].error = false
      this.files_sync = result
    },
    deleteFile(props) {
      if (this.externalDelete) {
        this.$emit('deleteFile', props)
        return
      }
      const result = this.$_.cloneDeep(this.files_sync)
      if (props.file.fileId) {
        result[props.n].deleted = true
      } else {
        result.splice(props.n, 1)
      }
      this.files_sync = result
    },
    close() {
      this.$emit('close')
      this.dialog = false
    },
    async applyFunnc() {
      if ( this.apply ) {
        await this.apply()
      }
      this.$emit('apply')
      this.dialog = false
    },
    open() {
      this.dialog = true
    },
  },
  components: {
    ImportBlock,
    DialogTemplateToolkit,
  }
}
</script>
